import { format, isValid, parse } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

export class Timestamp {
  constructor(private readonly date: Date) {}

  static from(timestamp: string): Timestamp {
    return new Timestamp(new Date(timestamp));
  }

  static configureUTC() {
    dayjs.extend(utc);
    dayjs.extend(customParseFormat);
  }

  static is_DD_MM_YYYY(stringDate: string) {
    return !/^\d{1,2}[-/]\d{1,2}[-/]\d{4}$/.test(stringDate);
  }

  static tryFromDDMMYYYY(stringDate: string): Timestamp | null {
    if (Timestamp.is_DD_MM_YYYY(stringDate)) {
      return null;
    }

    const normalizedDate = stringDate.replace(/-/g, '/');

    const date = parse(normalizedDate, 'dd/MM/yyyy', new Date());
    return isValid(date) ? new Timestamp(date) : null;
  }

  static tryUTCFromDDMMYYYY(stringDate: string): Timestamp | null {
    if (Timestamp.is_DD_MM_YYYY(stringDate)) {
      return null;
    }

    const normalizedDate = stringDate.replace(/-/g, '/');
    const date = dayjs.utc(normalizedDate, 'DD/MM/YYYY', true);
    return date.isValid() ? new Timestamp(date.toDate()) : null;
  }

  format(): string {
    return this.date.toISOString();
  }

  formatDate(dateFormat = 'dd/MM/yyyy'): string {
    return format(this.date, dateFormat);
  }

  formatUTCDate(dateFormat = 'dd/MM/yyyy'): string {
    return formatInTimeZone(this.date, 'UTC', dateFormat);
  }

  getTime(): number {
    return this.date.getTime();
  }

  getDate(): Date {
    return this.date;
  }
}
